import { SalesOpportunityPipeline } from '../../services/salesOpportunitiesApi';
import { getStageConfig } from '../../types/OpportunityStage';

type PipelineSummaryBarProps = {
  pipeline: SalesOpportunityPipeline;
};

function formatCurrency(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function PipelineSummaryBar({ pipeline }: PipelineSummaryBarProps) {
  return (
    <div className="erp-card">
      <div className="erp-card-body space-y-4">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="erp-card-title">Resumo do pipeline</h2>
            <p className="erp-card-subtitle">
              {pipeline.totalCount} oportunidade(s) — valor em aberto:{' '}
              <strong>{formatCurrency(pipeline.pipelineValue)}</strong>
            </p>
          </div>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
          {pipeline.stages.map((stage) => {
            const config = getStageConfig(stage.stage);
            return (
              <div
                key={stage.stage}
                className={`rounded-xl border p-3 ${config.columnClass}`}
              >
                <p className={`inline-flex rounded-lg px-2 py-0.5 text-xs font-semibold ${config.headerClass}`}>
                  {config.label}
                </p>
                <p className="mt-2 text-2xl font-bold text-secondary-900">{stage.count}</p>
                <p className="text-sm font-medium text-secondary-700">{formatCurrency(stage.totalAmount)}</p>
                {stage.totalMonthlyRecurring > 0 ? (
                  <p className="erp-hint">MRR: {formatCurrency(stage.totalMonthlyRecurring)}</p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
